module.exports = __webpack_public_path__ + "static/header2-c79ef77ad22ae72ed966063a4377775c.png";